import { render, staticRenderFns } from "./adapt-study.vue?vue&type=template&id=c125d912&scoped=true"
import script from "./adapt-study.vue?vue&type=script&lang=js"
export * from "./adapt-study.vue?vue&type=script&lang=js"
import style0 from "./adapt-study.vue?vue&type=style&index=0&id=c125d912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c125d912",
  null
  
)

export default component.exports